import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { Eye, Award, Gem } from 'lucide-react';
export function SpecialtySection() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      label: 'WHAT I DO',
      headline: 'Black & White Realism. Zero Compromises.',
      cards: [{
        icon: <Eye className="w-8 h-8 text-brand-gold" strokeWidth={1} data-id="element-154" />,
        title: 'Fine Art Realism',
        text: 'Trained as a painter, I bring fine art techniques directly to skin. Every shadow, every highlight, every detail is intentional.'
      }, {
        icon: <Award className="w-8 h-8 text-brand-gold" strokeWidth={1} data-id="element-155" />,
        title: 'Academic Foundation',
        text: 'Graduate of the Academy of Plastic Arts. Painting specialization. This is not just tattooing. This is fine art.'
      }, {
        icon: <Gem className="w-8 h-8 text-brand-gold" strokeWidth={1} data-id="element-156" />,
        title: '100% Custom',
        text: 'No flash. No templates. Every design is created exclusively for you and your story.'
      }]
    },
    es: {
      label: 'LO QUE HAGO',
      headline: 'Realismo Blanco y Negro. Cero Compromisos.',
      cards: [{
        icon: <Eye className="w-8 h-8 text-brand-gold" strokeWidth={1} data-id="element-157" />,
        title: 'Realismo Fine Art',
        text: 'Formado como pintor, llevo técnicas de arte directamente a la piel. Cada sombra, cada luz, cada detalle es intencional.'
      }, {
        icon: <Award className="w-8 h-8 text-brand-gold" strokeWidth={1} data-id="element-158" />,
        title: 'Base Académica',
        text: 'Graduado de la Academia de Artes Plásticas. Especialidad Pintura. Esto no es solo tatuar. Esto es arte.'
      }, {
        icon: <Gem className="w-8 h-8 text-brand-gold" strokeWidth={1} data-id="element-159" />,
        title: '100% Personalizado',
        text: 'Sin flash. Sin plantillas. Cada diseño se crea exclusivamente para ti y tu historia.'
      }]
    }
  };
  const t = content[language];
  return <section className="py-24 md:py-32 px-6 border-b border-brand-gold/30" data-id="element-160">
      <div className="max-w-7xl mx-auto" data-id="element-161">
        <motion.div className="mb-16 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-162">
          <span className="text-brand-gold font-sans tracking-[0.3em] uppercase block mb-4 text-[40px]" data-id="element-163">
            {t.label}
          </span>
          <h2 className="md:text-5xl lg:text-6xl font-serif text-brand-gold max-w-3xl mx-auto text-[36px]" data-id="element-164">
            {language === 'en' ? '"From photorealistic portraits to precision fine lines, from wildlife to architecture, from small pieces to large-scale compositions — every style I work in is executed with the same academic precision and artistic sensitivity I developed as a trained painter. Black and white realism is my foundation. But my range has no limits."' : '"Desde retratos fotorrealistas hasta líneas finas de precisión milimétrica, desde fauna salvaje hasta arquitectura, desde piezas pequeñas hasta composiciones de gran formato — cada estilo que trabajo se ejecuta con la misma precisión académica y sensibilidad artística que desarrollé como pintor formado. El realismo blanco y negro es mi base. Pero mi rango no tiene límites."'}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-165">
          {t.cards.map((card, index) => <motion.div key={index} className="bg-brand-charcoal border border-brand-gold/50 p-10 flex flex-col items-center text-center transition-all duration-500 hover:shadow-[0_0_20px_rgba(201,168,76,0.15)] hover:border-brand-gold" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} data-id="element-166">
              <div className="mb-6 p-4 rounded-full bg-brand-black border border-brand-gold/30" data-id="element-167">
                {card.icon}
              </div>
              <h3 className="text-2xl font-serif text-brand-gold mb-4" data-id="element-168">
                {card.title}
              </h3>
              <p className="text-brand-white/80 font-sans font-light leading-relaxed" data-id="element-169">
                {card.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}